<template>
    <div :id="id" class="row">
      <LmTextInput
        ref="inputFocus"
        :id="id + 'label'"
        class="col-12 col-md-4"
        v-model="component.componentProps.label"
        @input="$emit('input', component)"
        label="Label"
        placeholder="Label"
      />
      <LmTextInput
        class="col-12 col-md-4"
        :id="id + 'nombre'"
        v-model="component.formObjectToSendToServerProperty"
        @input="$emit('input', component); $emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
        label="Nombre"
        placeholder="placeholder"
      />
      <LmTextInput
        class="col-12 col-md-4"
        :id="id + 'placeholder'"
        v-model="component.componentProps.placeholder"
        @input="$emit('input', component)"
        label="placeholder"
        placeholder="placeholder"
      />
      <LmSelect
        :id="id + 'css'"
        class="col-12 col-md-4"
        v-model="component.class"
        :options="{
          content: [
            {value: 'col-12 col-md-3',text: '25%'},
            {value: 'col-12 col-md-6', text: '50%'},
            {value: 'col-12 col-md-9', text: '75%'},
            {value: 'col-12 col-md-12', text: '100%'}
          ]
        }"
        label="Ancho vista escritorio"
        :help="$t('help_width_form_element')"
        @input="$emit('input', component)"
      />
      <div class="col-12">
        <h5>Validation</h5>
        <div class="row align-items-center">
          <div class="custom-control custom-checkbox col-12 col-md mt-1">
            <b-form-checkbox
              :name="component.formObjectToSendToServerProperty"
              v-model="validations.required"
              @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
              >
              required
            </b-form-checkbox>
          </div>
          <LmNumberInput
            :id="`min-length-${id}`"
            class="col-12 col-md-4"
            v-model="validations.minLength"
            @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
            label="minLength"
            />
          <LmNumberInput
            :id="`max-length-${id}`"
            class="col-12 col-md-4"
            v-model="validations.maxLength"
            @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
            label="maxLength"
            />
          <LmSelect
            v-if="component.componentName !== 'LmEditor'"
            :id="id + 'same-as'"
            class="col-12 col-md-4"
            v-model="validations.sameAs"
            :options="optionsSameAsValidation"
            label="El valor tiene que ser igual a"
            @input="onInputValidationSameAs(optionsSameAsValidation.content.find(e => e.value === validations.sameAs))"
          />
        </div>
      </div>
      <LmConditionalBuilderUi
        v-if="isVisibleCondition"
        class="col-12"
        :visibilityDependOnConditions="visibilityDependOnConditions"
        :self="component.formObjectToSendToServerProperty"
      />
      <LmConditionalByEditModeBuilderUi
        :component="component"
        @input="$emit('input', component)"
        />
    </div>
</template>

<script>
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'
export default {
  mixins: [lmFormElementsBuilderUiMixin],
  data () {
    return {
      validations: {
        required: false,
        minLength: '',
        maxLength: '',
        sameAs: ''
      }
    }
  },
  watch: {
    componentData () {
      this.component = this.componentData
    }
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    }
  }
}
</script>
